/*
    Paralax jQuery Plugin
    Tirien.com
    $Rev: 1 $

    To initiate within markup use:
    <div data-parallax-distance='20'>...</div>

    Distance can be 0.5 or above. The greater distance, the objects move slower.
*/

(function ($) {
    $.tParallax = function (index, element) {
        var $element = $(element);
        var offset = $element.offset().top - $(window).height() / 2 - $(window).scrollTop();
        var distance = $element.data('parallax-distance');

        // Add error checking
        if (!distance || distance <= 0) {
            return;
        }

        $element.css({
            'transform': "translateY(" + offset / distance + "px)"
        });
    }

    $(document).ready(function () {
        $('[data-parallax-distance]').each(function () {
            var $this = $(this);

            if ($this.css('transform') != 'none') {
                console.warn("Parallax element can't have transform defined. Please, add wrapper and use tParallax on that wrapper.");
                return true; // Continue to next element
            }

            if ($this.css('transition-duration') != '0s') {
                console.warn("Parallax element can't have transition duration defined. Please, add wrapper and use tParallax on that wrapper.");
                return true; // Continue to next element
            }

            // FIX: Check parallax-distance instead of transition-duration
            var distance = $this.data('parallax-distance');
            if (!distance || distance < 1) {
                console.warn("Parallax element must have distance at least 1.");
                return true; // Continue to next element
            }

            $this.attr('data-tparallax-allowed', '');
        });
    });

    // Throttle scroll event for better performance
    var scrollTimeout;
    $(window).scroll(function () {
        if (scrollTimeout) {
            clearTimeout(scrollTimeout);
        }

        scrollTimeout = setTimeout(function () {
            $('[data-tparallax-allowed]').each($.tParallax);
        }, 16); // ~60fps
    });

    $(document).ready(function () {
        $('[data-tparallax-allowed]').each($.tParallax);
    });

})(jQuery);